import React, { FC, useEffect, useMemo, useState } from "react";
import Config from "../../config/Config";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";
import TabsMobile from "../__template/TabsMobileComponent";
import users from "../../assets/images/icon_profile/user.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";
import clock from "../../assets/images/clock.svg";
import arrowUp from "../../assets/images/arrow-up.svg";
import { Tab } from "@headlessui/react";
import DatePicker from "react-datepicker";
import * as API from "../../core/service/api_attendance.js";
import CustomApp from "../../core/models/customApp";
import { setLoading } from "../../core/feature/config/configSlice";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import { Parallax } from "react-scroll-parallax";
import { LazyLoadImage } from "react-lazy-load-image-component";

interface HistoryAttendanceProps {
  callerId?: string;
}
const ComponentSpecialShift: FC<HistoryAttendanceProps> = (
  props
): JSX.Element => {
  const user: User = useAppSelector((state) => state.user.user);
  const navigate = useNavigate();
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const dispatch = useAppDispatch();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const [startDate, setStartDate] = useState(
    new Date(currentYear, currentMonth, 1)
  );
  const [statistic, setStatistic] = useState<any>({});
  const [statisticDetail, setStatisticDetail] = useState<any>([]);
  const [detail, setDetail] = useState<any>({});
  const [openDetailHistory, setOpenDetailHistory] = useState(false);
  const [totals, setTotals] = useState<any>({});
  const [page, setPage] = useState(0);
  const [indexes, setIndexes] = useState(0);
  const [size, setSize] = useState(5);
  const { t } = useTranslation();
  const labels: any = {
    totalAlpa: "Alpa",
    totalAttendance: "Hadir",
  };

  const currentStatisticDetail = useMemo(() => {
    const a = statisticDetail.length;
    const b = a / (page + 1);

    return b;
  }, [statisticDetail]);

  const getStatistic = () => {
    let startDateFilter = moment(startDate).format("YYYY-MM-DD");
    let endDateFilter = moment(startDate).add(29, "days").format("YYYY-MM-DD");

    API.getAttendanceSpecialShift(
      startDateFilter,
      endDateFilter,
      props.callerId
    )
      .then((res) => {
        setStatistic(res.data.content.length ? res.data.content[0] : {});
        setTotals(calculateTotals(res.data.content));
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const getStatisticDetail = () => {
    dispatch(setLoading(true));
    let startDateFilter = moment(startDate).format("YYYY-MM-DD");
    let endDateFilter = moment(startDate).add(29, "days").format("YYYY-MM-DD");
    API.getAttendanceSpecialDetail(
      size,
      page,
      startDateFilter,
      endDateFilter,
      props.callerId
    )
      .then((res) => {
        dispatch(setLoading(false));
        setStatisticDetail(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
      });
  };

  const addMoreDetail = async () => {
    setPage(page + 1);
    setIndexes(indexes + 10);
    let startDateFilter = moment(startDate).format("YYYY-MM-DD");
    let endDateFilter = moment(startDate).add(29, "days").format("YYYY-MM-DD");
    API.getAttendanceSpecialDetail(
      size,
      page + 1,
      startDateFilter,
      endDateFilter,
      props.callerId
    )
      .then((res) => {
        // dispatch(setLoading(false));
        setStatisticDetail(res.data.content.concat(res.data.content));
      })
      .catch((err: any) => {
        // dispatch(setLoading(false));
      });
  };

  const calculateTotals = (data: any) => {
    let totalHadir = 0;
    let totalAlpa = 0;

    data.forEach((person: any) => {
      person.shifts.forEach((shift: any) => {
        shift.details.forEach((detail: any) => {
          totalHadir += parseInt(detail.total_hadir, 10);
          totalAlpa += parseInt(detail.total_alpa, 10);
        });
      });
    });

    return { totalHadir, totalAlpa };
  };

  function onDismissDetailHistory() {
    setOpenDetailHistory(false);
  }

  const openSheetDetailHistory = async () => {
    setOpenDetailHistory(true);
  };

  useEffect(() => {
    if (props.callerId) {
      getStatistic();
      getStatisticDetail();
    }
  }, [startDate, props.callerId]);

  return (
    <div>
      <BottomSheet
        className="z-40"
        open={openDetailHistory}
        onDismiss={onDismissDetailHistory}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ minHeight, maxHeight }) => [minHeight, maxHeight / 0.6]}
        header={
          <h1 className="font-poppins flex items-left text-xs  font-bold text-black">
            {moment(detail.attendanceDate).format("DD MMMM YYYY")}
          </h1>
        }
      >
        <div className="px-4 pt-2 pb-4">
          <p className="font-montserrat font-bold text-xs text-slate-500">
            {detail.shiftName}
          </p>
          <p className="font-montserrat font-medium text-xs text-slate-500">
            {detail.shiftDetailName}
          </p>
          <div className="flex">
            <p className="mr-2 font-montserrat font-medium text-xs text-slate-500">
              Keterangan
            </p>
            <p
              className={`mt-0 font-montserrat font-bold text-xs 
                ${
                  detail.information === "ALPA" ? "text-red" : "text-green-500"
                }`}
            >
              {detail.information}
            </p>
          </div>
          <div className="bg-gray-200 rounded-md ">
            <div className="grid grid-cols-2 p-3">
              <div className="flex items-center">
                <p className="font-montserrat text-black text-xs mb-0">
                  {detail.tapInTime ? detail.tapInTime : "-"}
                </p>
              </div>
              <div className="flex items-center">
                <p className="font-montserrat text-gray-400 text-xs mb-0">
                  Absen Masuk
                </p>
              </div>
            </div>
          </div>
        </div>
      </BottomSheet>
      <h1 className="font-bold text-sm font-montserrat grow">Filter Tanggal</h1>
      <DatePicker
        wrapperClassName="w-full"
        disabled={!props.callerId}
        className="w-full h-10 text-sm px-2 border-2 border-solid border-psp-gray rounded-lg"
        selected={startDate}
        onChange={(date: Date) => setStartDate(date)}
        showMonthYearPicker
        dateFormat="MMMM yyyy"
        // showIcon
        // icon="fas fa-calendar"
      />
      {Object.keys(statistic).length === 0 ? (
        <div className="flex justify-center my-3">
          <span className="font-normal text-xs text-center">
            {t("OTHER.dataNotFound")}
          </span>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-md font-montserrat my-3 relative">
          <div className="px-4 pt-2 ">
            <div className="grid grid-row-2 divide-y ">
              <h1 className="m-0 font-bold text-sm font-montserrat grow">
                Rekapitulasi
                <hr className="my-2" />
              </h1>
            </div>
            <div className="grid grid-cols-3 gap-0">
              <div className="flex no-underline w-full justify-center">
                <div className="flex flex-col items-center  w-fit">
                  <p className="text-center font-light text-xs text-slate-400 mb-0">
                    Hadir
                  </p>
                  <p className="text-center font-bold text-sm">
                    {totals.totalHadir}
                  </p>
                </div>
              </div>
              <div className="flex no-underline w-full justify-center">
                <div className="flex flex-col items-center  w-fit">
                  <p className="text-center font-light text-xs text-slate-400 mb-0">
                    Alpa
                  </p>
                  <p className="text-center font-bold text-sm">
                    {totals.totalAlpa}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <Parallax speed={0} className="absolute bottom-0 right-0 z-10">
            <LazyLoadImage
              className="inline rounded-xl"
              effect="blur"
              src={clock}
            />
          </Parallax>
        </div>
      )}

      {statisticDetail.map((data: any, index: any) => {
        return (
          <div
            key={index}
            className="bg-white rounded-xl shadow-md my-3 px-4 py-2 flex justify-between"
            onClick={() => {
              openSheetDetailHistory();
              setDetail(data);
            }}
          >
            <div className="flex flex-col w-1/3">
              <p className="text-xs font-medium mb-0 w-full font-montserrat truncate">
                {moment(data.attendanceDate).format("DD MMMM")}
              </p>
              <p className="text-xs font-bold mb-0 w-full font-montserrat truncate">
                {data.shiftName}
              </p>
              <p className="font-light text-xs text-slate-400 mb-0">
                {data.shiftDetailName}
              </p>
            </div>
            <div className="flex flex-col w-1/3">
              <p className="text-sm font-normal mb-0 font-montserrat">
                {data.attendanceTime ? data.attendanceTime : "-"}
              </p>
              <p className="font-light text-xs text-slate-400 mb-0">
                Absen Masuk
              </p>
            </div>
            <div className="flex flex-col items-center">
              <img
                src={arrowUp}
                // style={{ width: 6, height: 12 }}
                className="m-auto"
              />
            </div>
          </div>
        );
      })}
      {currentStatisticDetail < 5 ? (
        ""
      ) : (
        <div className="flex w-full">
          <button
            onClick={addMoreDetail}
            style={{ color: customApp?.app_accent_color }}
            className="w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active "
          >
            {t("OTHER.showMore")}
          </button>
        </div>
      )}
    </div>
  );
};

export default ComponentSpecialShift;
